module.exports = __webpack_public_path__ + "static/media/30_B.7b1b668f.png";